import { takeLatest } from 'redux-saga/effects';
import inboxFetchRequest from './inboxWorkerSaga';
import { INBOX_FETCH_REQUEST } from '../../redux/modules/inbox/inbox-actions';


export default function* inboxFetchSaga() {
    yield takeLatest(INBOX_FETCH_REQUEST, inboxFetchRequest);
}
